export const heplerChip = (
  c: string,
  setante: any,
  handleNotification: any,
  currency: string,
  maxBet: number,
  toFix: number
) => {
  const limit = maxBet
  setante((s: any) =>
    sum(
      limit,
      s,
      c,
      toFix,
      handleNotification,
      `Max bet limit of ANTE is ${limit.toFixed(toFix)} ${currency}`,
    ),
  )
}

const sum = (limit: number, a: string, b: string, toFix: number, handleNotification?: any, text?: string) => {
  let sumAB
  if (a.toString().includes('k') || b.toString().includes('k')) {
    const sum = sumNumbersWithString(a, b)
    sumAB = formatThousandWithDecimals(+sum)
  } else sumAB = (+round(+a + +b, toFix))
  return checkMaxStake(limit, sumAB.toString(), handleNotification, text)

}

function round(value: any, precision: number) {
  const multiplier = Math.pow(10, precision || 0)
  return Math.round(value * multiplier) / multiplier
}

const checkMaxStake = (limit: number, s: string, handleNotification?: any, text?: string) => {
  let num = s
  if (s.includes('k')) {
    num = replaceThousand(s).toString()
  }
  if (+num > limit) {
    handleNotification && handleNotification(text)
    return +limit > 999 ? formatMaxWithDecimals(+limit) : limit
    // return Math.floor(limit).toString()
  } else {
    return formatThousandWithDecimals(+num)
  }
}


export const formatThousand = (n: number) => {
  const roundToNearestThousand = Math.round(n / 1000) * 1000
  return roundToNearestThousand / 1000 + 'k'
}

export const formatThousandWithDecimals = (n: number) => {
  if (n > 999999) {
    return formatThousand(n)
  }
  else if (n > 999) {
    const rounded = (Math.floor(n / 1000 * 10) / 10)
    return rounded.toString().includes('.') ? rounded.toFixed(1) + 'k' : rounded + 'k';
  }
  else {
    return n ? n.toString() : '0';
  }
}

export const replaceThousand = (string: string) => parseFloat(string.includes('.') ? string.replace('.', '').replace('k', '00') : string.replace('k', '000'));


function sumNumbersWithString(num1Str: string, num2Str: string) {
  const num1 = replaceThousand(num1Str)
  const num2 = replaceThousand(num2Str)

  const result = num1 + num2;

  const resultStr = result.toString();

  return resultStr;
}


export const formatMax = (n: number) => {
  let newNum = Math.floor(n).toString()
  if (+newNum > 999) {
    return (newNum = formatThousand(n))
  }
  return newNum
}
export const formatMaxWithDecimals = (n: number) => {
  let newNum = Math.floor(n).toString()
  if (+newNum > 999) {
    return (newNum = formatThousandWithDecimals(n))
  }
  return newNum
}

export const formatMin = (n: number) => {
  if (+n > 999) {
    const rounded = (Math.ceil(n / 1000 * 10) / 10)
    return rounded.toString().includes('.') ? rounded.toFixed(1) + 'k' : rounded + 'k';
  } else return n.toString()
}